export const CLIENT_CLOSED_STATUS_CODE = 499;
